import { render, staticRenderFns } from "./PcfFeliratok.vue?vue&type=template&id=7b703fce&"
import script from "./PcfFeliratok.vue?vue&type=script&lang=js&"
export * from "./PcfFeliratok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports